<template>
    <div>

        <b-form @submit.prevent="newPromotion">
            <b-row class="mb-3">
                <b-col sm="6">
                    <b-form-group>
                        <label>{{$t('NAME')}}</label>
                        <b-form-input v-model="name" type="text" id="name_type" name="name_type"
                                      @change="$v.name.$touch"
                                      :state="$v.name.$dirty && $v.name.$invalid ? false : null"
                        ></b-form-input>
                        <validation-description :show="$v.name.$dirty && $v.name.$invalid">
                            Min input: 5 characters
                        </validation-description>
                    </b-form-group>
                </b-col>
                <b-col sm="4">
                    <b-form-group>
                        <label>{{$t('DISCOUNT')}}</label>
                        <b-form-input id="discount" name="discount" v-model="discount"
                                      @change="$v.discount.$touch"
                                      :state="$v.discount.$dirty && $v.discount.$invalid ? false : null"></b-form-input>
                        <validation-description :show="$v.discount.$dirty && $v.discount.$invalid">
                            {{$t('FIELD_NUMERIC')}}
                        </validation-description>
                    </b-form-group>
                </b-col>

                <b-col sm="2">
                    <b-form-group>
                        <label>{{$t('TYPE')}}</label>
                        <app-select :options="discountTypeOptions" v-model="discountType"
                                    @change="$v.discountType.$touch"></app-select>
                        <validation-description :show="$v.discountType.$dirty && $v.discountType.$invalid">
                            {{$t('FIELD_MANDATORY')}}
                        </validation-description>
                    </b-form-group>
                </b-col>
                <b-col sm="6">
                    <b-form-group>
                        <label> {{$t('BOOK_FROM_TO')}}</label>
                        <app-date-range-picker :min-date="new Date()" v-model="bookDate" :layout=" {default: 1, lg: 1}"></app-date-range-picker>
                    </b-form-group>
                </b-col>
                <b-col sm="6">
                    <b-form-group>
                        <label>{{$t('CHECK_IN_FROM_TO')}}</label>
                        <app-date-range-picker v-model="checkInDate" :layout=" {default: 1, lg: 1}"></app-date-range-picker>
                        <validation-description :show="$v.checkInDate.$dirty && $v.checkInDate.$invalid">
                            {{$t('FIELD_MANDATORY')}}
                        </validation-description>
                    </b-form-group>
                </b-col>
                <b-col sm="6">
                    <b-form-group>
                        <label>{{$t('MIN_DAYS_BEFORE_CHECK_IN')}}</label>
                        <b-form-input
                            id="min_days_advance"
                            name="min_days_advance"
                            v-model="minDaysAdvance"
                            @change="$v.minDaysAdvance.$touch"
                        ></b-form-input>
                        <validation-description :show="$v.minDaysAdvance.$dirty && $v.minDaysAdvance.$invalid">
                            {{$t('FIELD_NUMERIC')}}
                        </validation-description>
                    </b-form-group>
                </b-col>
                <b-col sm="6">
                    <b-form-group>
                        <label> {{$t('MIN_STAY_FROM_RATE_PLAN')}}</label>
                        <app-select :options="ratePlanList" v-model="ratePlan" :disabled="minStayValidate"></app-select>
                        <validation-description :show="$v.ratePlan.$dirty && $v.ratePlan.$invalid">
                            {{$t('FIELD_MANDATORY')}}
                        </validation-description>
                    </b-form-group>
                </b-col>
                <b-col sm="6">
                    <b-form-group>
                        <label>{{$t('MIN_STAY')}}</label>
                        <b-form-input
                            :disabled="ratePlanValidate"
                            id="min_stay"
                            name="min_stay"
                            v-model="minStay"
                        ></b-form-input>
                        <validation-description :show="$v.minStay.$dirty && $v.minStay.$invalid">
                            {{$t('FIELD_NUMERIC')}}
                        </validation-description>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="6">
                    <promotion-submit></promotion-submit>
                </b-col>
            </b-row>
        </b-form>
    </div>
</template>

<script>
    import PromotionSubmit from '@/components/app/AppButton/AppButtonSubmit'
    import PromotionDelete from '@/components/app/AppButton/AppButtonDelete'
    import PromotionDeleteDialog from '@/components/app/form/AppConfirmationDialog'
    import {toast} from '@/shared/plugins/toastr'
    import {PROMOTION_EARLY_BOOK} from "@/shared/constants"
    import {required, minLength, minValue, numeric, integer} from 'vuelidate/lib/validators'
    import ValidationDescription from '@/components/app/form/AppValidationDescription'
    import {getValidationRule} from '@/mixins/validation/getValidationRule'
    import {getErrorMessage} from '@/mixins/error/getErrorMessage'
    import requiredIf from "vuelidate/src/validators/requiredIf";
    import moment from 'moment'
    import AppSelect from "@/components/app/AppSelect/AppSelect";
    import AppDateRangePicker from "@/components/app/datetime/AppDateRangePicker";

    export default {
        name: "promotion-early-booker-new-form",
        props: ['ratePlanList'],
        data() {
            return {
                discountTypeOptions: [
                    {id: 1, name: '%'},
                    {id: 2, name: 'fix'},

                ],
                name: 'Early booker',
                discount: null,
                discountType: null,
                minDaysAdvance: null,
                minStay: null,
                ratePlan: null,
                bookDate: {
                    start: null,
                    end: null,
                },
                checkInDate: {
                    start: null,
                    end: null,
                },


            }
        },
        mixins: [getValidationRule, getErrorMessage],
        validations: {
            discount: {
                required, integer
            },
            discountType: {
                required,
            },
            minDaysAdvance: {
                required,
                minLength: 1,
                minValue: minValue(1),
                numeric
            },
            name: {
                required,
                minLength: minLength(5),
            },
            checkInDate: {
                start: {required},
                end: {required}
            },
            minStay: {
                required: requiredIf(function () {
                    return !this.ratePlan
                }),
                numeric
            },
            ratePlan: {
                required: requiredIf(function () {
                    return !this.minStay
                }),
            },
            bookDate: {
                required
            }

        },
        components: {
            AppDateRangePicker,
            PromotionSubmit,
            PromotionDelete,
            PromotionDeleteDialog,
            ValidationDescription,
            AppSelect
        },
        computed: {
            inputState() {
                if (!this.selectedValue) {
                    return {
                        type: 'is-danger',
                        message: 'Date required.',
                    };
                }
                return {
                    type: 'is-primary',
                    message: '',
                };
            },
            minStayValidate() {
                if (!this.minStay) {
                    return false;
                } else {
                    return true
                }
            },
            ratePlanValidate() {
                if (!this.ratePlan) {
                    return false
                } else {
                    return true
                }
            }
        },

        methods: {
            newPromotion() {
                this.$v.$touch()
                if (this.$v.$invalid) {
                    toast({
                        'title': "",
                        'message': this.$t('VALIDATION_FAILED'),
                        'type': 'error',
                        'timeout': 6000
                    })
                    return

                }
                let promotion = {
                    name: this.name,
                    discount: this.discount,
                    promotion_type: PROMOTION_EARLY_BOOK,
                    discount_type: this.discountType,
                    book_date_from: moment(this.bookDate.start).format('YYYY-MM-DD'),
                    book_date_to: moment(this.bookDate.end).format('YYYY-MM-DD'),
                    checkin_date_from: moment(this.checkInDate.start).format('YYYY-MM-DD'),
                    checkin_date_to: moment(this.checkInDate.end).format('YYYY-MM-DD'),
                    min_stay: this.minStay,
                    min_stay_rate_plan_id: this.ratePlan,
                    min_days_advance: this.minDaysAdvance,
                }
                this.$store.dispatch('property/actionCreatePropertyPromotion', promotion)
                    .then(() => {
                        toast({
                            'title': this.$t('NOTIFICATIONS.SAVE_SUCCESS.TITLE'),
                            'message': this.$t('NOTIFICATIONS.SAVE_SUCCESS.MESSAGE'),
                            'type': 'success',
                            'timeout': 2000
                        })
                        this.$emit('promotionSaved')
                    }, error => {
                        toast({
                            'title': "Action fail",
                            'message': this.getMessages(error),
                            'type': 'error',
                            'timeout': 2000
                        })
                    })
            },
        },

    }
</script>

<style scoped>

</style>
